import { render, staticRenderFns } from "./DirectMessageWindow.vue?vue&type=template&id=3dd20c9e&"
import script from "./DirectMessageWindow.vue?vue&type=script&lang=js&"
export * from "./DirectMessageWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports